import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Paginação compartilhada das listas do Troco (Controle, Depósito, Confirmação).
// Padrão visual alinhado ao histórico do BSV.
export const ITENS_POR_PAGINA = 10;

const btnPag = (off) => ({
    display: 'inline-flex', alignItems: 'center', gap: 4,
    padding: '8px 12px',
    background: off ? '#f1f5f9' : '#fff', color: off ? '#94a3b8' : '#475569',
    border: '1px solid #cbd5e1', borderRadius: 6,
    fontWeight: 700, fontSize: 13, cursor: off ? 'not-allowed' : 'pointer',
});

export const Paginacao = ({ pagina, totalPaginas, onChange }) => {
    if (totalPaginas <= 1) return null;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <button onClick={() => onChange(1)} disabled={pagina === 1} style={btnPag(pagina === 1)}>« Primeira</button>
            <button onClick={() => onChange(Math.max(1, pagina - 1))} disabled={pagina === 1} style={btnPag(pagina === 1)}>
                <ChevronLeft size={14} /> Anterior
            </button>
            <span style={{ padding: '8px 14px', background: '#475569', color: '#fff', borderRadius: 6, fontWeight: 700, fontSize: 13 }}>
                {pagina} / {totalPaginas}
            </span>
            <button onClick={() => onChange(Math.min(totalPaginas, pagina + 1))} disabled={pagina === totalPaginas} style={btnPag(pagina === totalPaginas)}>
                Próxima <ChevronRight size={14} />
            </button>
            <button onClick={() => onChange(totalPaginas)} disabled={pagina === totalPaginas} style={btnPag(pagina === totalPaginas)}>Última »</button>
        </div>
    );
};
